import { CardContent } from '@mui/material'
import { isEmpty } from 'lodash'
import { useTranslate } from 'ra-core'
import { memo, useMemo } from 'react'

import PressureChart from './PressureChart'
import { useCommonStyles } from '../config/theme'
import { CardTitle } from '../resources/common'
import { ShowCard } from '../resources/common/show'
import { getDefaultBrushIndexes, mergePressureSeries } from '../utils/pressureGraph'

const PressureGraph = memo(({ title, data }) => {
  const commonClasses = useCommonStyles()
  const translate = useTranslate()
  const points = useMemo(() => (isEmpty(data.total) ? [] : mergePressureSeries(data.total, data.used)), [data])
  const defaultBrushIndexes = useMemo(
    () => (isEmpty(points) ? {} : getDefaultBrushIndexes(points, Date.now())),
    [points],
  )

  if (isEmpty(points)) {
    return null
  }

  return (
    <ShowCard>
      <CardContent sx={{ borderBottom: '1px solid', borderColor: 'divider', ...commonClasses.titleContainer }}>
        <CardTitle text="mymove.statistics.utilisationRate" args={{ vehicleType: translate(title).toLowerCase() }} />
      </CardContent>
      <CardContent>
        <PressureChart points={points} height={400} brushIndexes={defaultBrushIndexes} />
      </CardContent>
    </ShowCard>
  )
})

export default PressureGraph
